import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
export const ALL_TAB_LABEL = '전체';

//* 정식 명칭에 글자가 그대로 들어 있지 않은 줄임말·옛 명칭만 둔다 — 「서울」「전남」은 부분일치로 이미 잡힌다
const PROVINCE_ALIASES: Record<string, string> = {
  충북: '충청북도',
  충남: '충청남도',
  경북: '경상북도',
  경남: '경상남도',
  강원도: '강원특별자치도',
  전라북도: '전북특별자치도',
  제주도: '제주특별자치도'
};
const removeWhitespace = (text: string) => text.replace(/\s/g, '');
const expandProvinceAlias = (keyword: string) => {
  const alias = Object.keys(PROVINCE_ALIASES).find(name => keyword.startsWith(name));
  return alias ? PROVINCE_ALIASES[alias] + keyword.slice(alias.length) : keyword;
};
export const useRegionFinder = t0 => {
  const $ = _c(29);
  const {
    enabled
  } = t0;
  const router = useCustomRouter();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedParentId, setSelectedParentId] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = keyword => {
      setSearchKeyword(keyword);
      setSelectedParentId(null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleSearchChange = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = UnauthQueryOptions["get:/wello/v2/allows/home-love-gov-code/parent"]();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== enabled) {
    t3 = {
      ...t2,
      select: _temp,
      enabled
    };
    $[2] = enabled;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const provincesQuery = useQuery(t3);
  let t4;
  if ($[4] !== selectedParentId) {
    t4 = UnauthQueryOptions["get:/wello/v2/allows/home-love-gov-code/child"]({
      query: {
        parentHomeLoveGovCodeId: selectedParentId ?? undefined
      }
    });
    $[4] = selectedParentId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== enabled || $[7] !== t4) {
    t5 = {
      ...t4,
      select: _temp2,
      enabled,
      placeholderData: keepPreviousData
    };
    $[6] = enabled;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const districtsQuery = useQuery(t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = parentId => {
      setSelectedParentId(parentId);
      setSearchKeyword("");
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleSelectParentId = t6;
  let t7;
  if ($[10] !== districtsQuery.data || $[11] !== searchKeyword) {
    const keyword_0 = removeWhitespace(searchKeyword);
    const searchKeys = [keyword_0, expandProvinceAlias(keyword_0)];
    t7 = (districtsQuery.data ?? []).filter(district => !keyword_0 || searchKeys.some(searchKey => removeWhitespace(district.fullName).includes(searchKey) || district.value.includes(searchKey))).map(_temp3);
    $[10] = districtsQuery.data;
    $[11] = searchKeyword;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const rows = t7;
  let t8;
  if ($[13] !== router) {
    t8 = id => {
      router.push(DONATION_ROUTES.HOMETOWNS_DETAIL.pathname({
        id
      }));
    };
    $[13] = router;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const handleSelectRegion = t8;
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setSearchKeyword("");
      setSelectedParentId(null);
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const reset = t9;
  const t10 = provincesQuery.isPending || districtsQuery.isPending;
  const t11 = provincesQuery.isError || districtsQuery.isError;
  const t12 = provincesQuery.isFetching || districtsQuery.isFetching;
  let t13;
  if ($[16] !== districtsQuery || $[17] !== provincesQuery) {
    t13 = () => Promise.all([provincesQuery.refetch(), districtsQuery.refetch()]);
    $[16] = districtsQuery;
    $[17] = provincesQuery;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== handleSelectRegion || $[20] !== provincesQuery.data || $[21] !== rows || $[22] !== searchKeyword || $[23] !== selectedParentId || $[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13) {
    t14 = {
      searchKeyword,
      selectedParentId,
      provinces: provincesQuery.data,
      rows,
      isPending: t10,
      isError: t11,
      isFetching: t12,
      retry: t13,
      handleSearchChange,
      handleSelectParentId,
      handleSelectRegion,
      reset
    };
    $[19] = handleSelectRegion;
    $[20] = provincesQuery.data;
    $[21] = rows;
    $[22] = searchKeyword;
    $[23] = selectedParentId;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};
function _temp(data) {
  return data.context?.contents ?? [];
}
function _temp2(data_0) {
  return data_0.context?.contents ?? [];
}
function _temp3(t0) {
  const {
    homeLoveGovCodeId,
    fullName,
    value,
    institutionSlugId
  } = t0;
  return {
    key: homeLoveGovCodeId,
    label: fullName,
    shortLabel: value.trim(),
    id: institutionSlugId
  };
}